import React, { useEffect, useState } from 'react';
import { EmailTemplate } from './components/EmailTemplate';
export function App() {
  const [selectedModule, setSelectedModule] = useState('signup');
  const [selectedTemplate, setSelectedTemplate] = useState('auth.signup.confirm_email');
  useEffect(() => {
    document.title = 'Email Template Catalog';
  }, []);
  const modules = [{
    id: 'signup',
    name: 'SignUp'
  }, {
    id: 'forgot_password',
    name: 'ForgotPassword'
  }, {
    id: 'login',
    name: 'Login'
  }, {
    id: 'claims',
    name: 'Claims'
  }];
  const templates = {
    signup: [{
      id: 'auth.signup.confirm_email',
      name: 'Email Confirmation'
    }, {
      id: 'auth.signup.welcome',
      name: 'Welcome Email'
    }, {
      id: 'auth.signup.resend_confirmation',
      name: 'Resend Confirmation'
    }, {
      id: 'auth.signup.activation_reminder',
      name: 'Activation Reminder'
    }, {
      id: 'auth.account.deletion_confirmation',
      name: 'Account Deletion Confirmation'
    }],
    forgot_password: [{
      id: 'auth.forgot_password.request',
      name: 'Password Reset Request'
    }, {
      id: 'auth.forgot_password.confirmed',
      name: 'Password Changed Confirmation'
    }, {
      id: 'auth.password.suspicious_attempts',
      name: 'Suspicious Reset Attempts'
    }, {
      id: 'auth.password.temp_lockout',
      name: 'Temporary Account Lockout'
    }],
    login: [{
      id: 'auth.login.new_device',
      name: 'New Device Sign-in'
    }, {
      id: 'auth.login.new_trusted_device',
      name: 'New Trusted Device Added'
    }, {
      id: 'auth.login.suspicious_blocked',
      name: 'Suspicious Sign-in Blocked'
    }, {
      id: 'auth.login.activity_summary',
      name: 'Activity Summary'
    }],
    claims: [{
      id: 'claims.dealer.claim_created',
      name: 'Claim Created (Dealer)'
    }, {
      id: 'claims.corporate.claim_created_assigned',
      name: 'Claim Assigned (Corporate)'
    }, {
      id: 'claims.dealer.claim_approved',
      name: 'Claim Approved (Dealer)'
    }, {
      id: 'claims.dealer.claim_resolved',
      name: 'Claim Resolved (Dealer)'
    }, {
      id: 'claims.dealer.claim_rejected_with_note',
      name: 'Claim Rejected (Dealer)'
    }, {
      id: 'claims.factory.issue_report_created',
      name: 'Factory Issue Report (Internal)'
    }]
  };
  const handleModuleChange = (moduleId: string) => {
    setSelectedModule(moduleId);
    setSelectedTemplate(templates[moduleId as keyof typeof templates][0].id);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      {/* Header with selectors */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm" data-id="element-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-2">
          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-3">
            <div className="flex items-center gap-3" data-id="element-4">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/Black_Drop.png" alt="Aisco" className="h-8 w-8" data-id="element-5" />
              <h1 className="text-xl font-semibold text-gray-900" data-id="element-6">
                Email Templates
              </h1>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 sm:ml-auto w-full sm:w-auto" data-id="element-7">
              <div className="flex flex-col gap-1.5" data-id="element-8">
                <label htmlFor="module" className="text-xs font-medium text-gray-700" data-id="element-9">
                  Module
                </label>
                <select id="module" value={selectedModule} onChange={e => handleModuleChange(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white" data-id="element-10">
                  {modules.map(module => <option key={module.id} value={module.id} data-id="element-11">
                      {module.name}
                    </option>)}
                </select>
              </div>

              <div className="flex flex-col gap-1.5" data-id="element-12">
                <label htmlFor="template" className="text-xs font-medium text-gray-700" data-id="element-13">
                  Template
                </label>
                <select id="template" value={selectedTemplate} onChange={e => setSelectedTemplate(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white min-w-[240px]" data-id="element-14">
                  {templates[selectedModule as keyof typeof templates].map(template => <option key={template.id} value={template.id} data-id="element-15">
                        {template.name}
                      </option>)}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Email preview */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-16">
        <EmailTemplate templateId={selectedTemplate} data-id="element-17" />
      </div>
    </div>;
}